import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { APIRoutes } from '@api';

const Option = styled.a`
  display: block;
  color: inherit;
  font-size: 14px;
  padding: 12px;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
`;

const TrackDownloadTooltipBody = ({ options, id }) => {
  return (
    <div>
      {options.map(({ label, value }, index) => (
        <Option
          key={`${id}-${value}-${index}`}
          onClick={ev => {
            ev.stopPropagation();
          }}
          href={APIRoutes.DOWNLOAD_TRACK(id, value)}
          download
        >
          {label}
        </Option>
      ))}
    </div>
  );
};

TrackDownloadTooltipBody.propTypes = {
  options: PropTypes.array.isRequired,
  id: PropTypes.number.isRequired,
};

export default TrackDownloadTooltipBody;
